import { render, staticRenderFns } from "./ODP.vue?vue&type=template&id=0f998d70&"
import script from "./ODP.vue?vue&type=script&lang=js&"
export * from "./ODP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f998d70')) {
      api.createRecord('0f998d70', component.options)
    } else {
      api.reload('0f998d70', component.options)
    }
    module.hot.accept("./ODP.vue?vue&type=template&id=0f998d70&", function () {
      api.rerender('0f998d70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/72235100-2/ODP.vue"
export default component.exports